<template>
    <div>
        <p v-html="content"></p>   
    </div>   
</template>

<script>
export default {
    data(){
        return{
            content:null
        }
    },
    mounted(){
          this.privacy()
    },
    methods:{
        privacy(){
            this.joker.privacy.getPrivacyPolicy().then(res=>{
                console.log(res)
                this.content = res.content
            })
        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/privacy/privacy.vue